import React, { useState, useCallback, useEffect } from 'react';
import { orderApi } from '../../lib/orderApi';
import { goldButton } from '../PageShell';

const cfgInput = { background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.25)', color: '#F5F5F0', padding: '9px 11px', fontSize: '13px', outline: 'none', width: '100%' };

const RESULT_STYLES = {
  processed: { background: 'rgba(127,183,126,0.2)', color: '#7FB77E' },
  rejected: { background: 'rgba(200,40,43,0.2)', color: '#E0736F' },
  default: { background: 'rgba(201,168,76,0.2)', color: '#C9A84C' },
};
const resultStyle = (result) => RESULT_STYLES[result] || RESULT_STYLES.default;

const AdminWebhooks = ({ isOpen }) => {
  const [webhookLogs, setWebhookLogs] = useState([]);
  const [webhookFilter, setWebhookFilter] = useState('');
  const [webhookLoading, setWebhookLoading] = useState(false);

  const loadWebhookLogs = useCallback(async (filter = '') => {
    setWebhookLoading(true);
    try {
      const params = { limit: 100 };
      if (filter) params.result = filter;
      const { data } = await orderApi.get('/admin/webhook-logs', { params });
      setWebhookLogs(data.logs || []);
    } catch {
      setWebhookLogs([]);
    } finally {
      setWebhookLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isOpen) loadWebhookLogs(webhookFilter);
  }, [isOpen, loadWebhookLogs, webhookFilter]);

  if (!isOpen) return null;

  return (
    <div className="mt-5 p-5" style={{ background: '#141414', border: '1px solid rgba(201,168,76,0.3)' }} data-testid="webhook-panel">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <div>
          <h3 className="font-display" style={{ fontSize: '18px', fontWeight: 700, color: '#F5F5F0' }}>Webhook Logs</h3>
          <p className="font-body mt-1" style={{ fontSize: '12px', color: '#C2C1B6' }}>
            Registro de eventos de Stripe para auditoría y debug.
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <select
            value={webhookFilter}
            onChange={(e) => {
              setWebhookFilter(e.target.value);
              loadWebhookLogs(e.target.value);
            }}
            style={{ ...cfgInput, width: 'auto', minWidth: '140px' }}
            data-testid="webhook-filter"
          >
            <option value="">Todos</option>
            <option value="processed">Procesados</option>
            <option value="rejected">Rechazados</option>
          </select>
          <button onClick={() => loadWebhookLogs(webhookFilter)} style={goldButton} data-testid="webhook-refresh">
            {webhookLoading ? 'Cargando...' : 'Actualizar'}
          </button>
        </div>
      </div>

      {webhookLogs.length === 0 ? (
        <p className="font-body" style={{ fontSize: '13px', color: '#C2C1B6', textAlign: 'center', padding: '20px' }}>
          {webhookLoading ? 'Cargando logs...' : 'No hay webhooks registrados.'}
        </p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(201,168,76,0.25)' }}>
                <th style={{ textAlign: 'left', padding: '10px 8px', color: '#C9A84C', fontWeight: 600, fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Fecha
                </th>
                <th style={{ textAlign: 'left', padding: '10px 8px', color: '#C9A84C', fontWeight: 600, fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Resultado
                </th>
                <th style={{ textAlign: 'left', padding: '10px 8px', color: '#C9A84C', fontWeight: 600, fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Firma
                </th>
                <th style={{ textAlign: 'left', padding: '10px 8px', color: '#C9A84C', fontWeight: 600, fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Tipo
                </th>
                <th style={{ textAlign: 'left', padding: '10px 8px', color: '#C9A84C', fontWeight: 600, fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Session ID
                </th>
                <th style={{ textAlign: 'left', padding: '10px 8px', color: '#C9A84C', fontWeight: 600, fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  IP
                </th>
                <th style={{ textAlign: 'left', padding: '10px 8px', color: '#C9A84C', fontWeight: 600, fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                  Error
                </th>
              </tr>
            </thead>
            <tbody>
              {webhookLogs.map((log, idx) => (
                <tr key={`${log.timestamp}-${log.ip}-${idx}`} style={{ borderBottom: '1px solid rgba(201,168,76,0.1)' }} data-testid={`webhook-row-${idx}`}>
                  <td style={{ padding: '10px 8px', color: '#C2C1B6', whiteSpace: 'nowrap' }}>
                    {log.timestamp ? new Date(log.timestamp).toLocaleString('es-PR', { dateStyle: 'short', timeStyle: 'medium' }) : '-'}
                  </td>
                  <td style={{ padding: '10px 8px' }}>
                    <span
                      style={{
                        display: 'inline-block',
                        padding: '3px 8px',
                        fontSize: '10px',
                        fontWeight: 600,
                        background: resultStyle(log.result).background,
                        color: resultStyle(log.result).color,
                        borderRadius: '3px',
                        textTransform: 'uppercase',
                      }}
                    >
                      {log.result || 'unknown'}
                    </span>
                  </td>
                  <td style={{ padding: '10px 8px' }}>
                    {log.signature_valid ? (
                      <span style={{ color: '#7FB77E' }}>✓ Válida</span>
                    ) : (
                      <span style={{ color: '#E0736F' }}>✗ Inválida</span>
                    )}
                  </td>
                  <td style={{ padding: '10px 8px', color: '#F5F5F0' }}>{log.event_type || '-'}</td>
                  <td style={{ padding: '10px 8px', color: '#C2C1B6', fontFamily: 'monospace', fontSize: '11px' }}>
                    {log.session_id ? `${log.session_id.slice(0, 16)}...` : '-'}
                  </td>
                  <td style={{ padding: '10px 8px', color: '#C2C1B6', fontFamily: 'monospace', fontSize: '11px' }}>{log.ip || '-'}</td>
                  <td
                    style={{
                      padding: '10px 8px',
                      color: '#E0736F',
                      fontSize: '11px',
                      maxWidth: '200px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={log.error || ''}
                  >
                    {log.error || '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <p className="font-body mt-3" style={{ fontSize: '11px', color: '#888880' }}>
        Mostrando {webhookLogs.length} logs. Los webhooks rechazados pueden indicar intentos de falsificación o errores de configuración.
      </p>
    </div>
  );
};

export default AdminWebhooks;
